import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { CongregationDeleted, deleteCongregation } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useDeleteCongregation = (
  options: UseMutationOptions<CongregationDeleted, unknown, number, unknown>
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (congregationId) => {
      const result = await extractData(
        deleteCongregation({ path: { id: congregationId } })
      );
      return result;
    },
    ...options,
    onSuccess(...args) {
      queryClient.invalidateQueries({
        queryKey: ['congregations'],
      });
      options.onSuccess?.(...args);
    },
  });
};
